define('mixins/graph/graph-mixin',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/i18n',
    'services/user',
    // collections
    'collections/calendar/personal-data/personal-data-types',
], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // services
    i18n,
    User,
    // collections
    CPersonalDataTypes
) {

    return {
        loadGraph: function() {
            this.model.reset()
                .fetch({
                    context: this,
                    success: this.renderGraph,
                    user: this.profile.id
                });
        },

        getDatasetUnit: function(type) {
            var units = User.get('units');
            if (!units) return;

            if (type.indexOf('custom') !== -1) {
                var customData_id = type.split(':')[1],
                    customData = this.personalData.get(customData_id);

                if (customData.isConvertible()) {
                    return customData.getUserUnit();
                }
                return customData.get('unit');
            }

            switch (type) {
                case 'calories':
                    return 'calories';
                case 'feedback_level':
                    return 'feedback';
                case 'duration':
                    return 'minutes';
                case 'waistline':
                    return units.length;
                default:
                    return units[type];
            }
        },

        getMinDateByFrequency: function(date, frequency) {
            if (frequency === 'weekly') {
                date = moment(date).startOf('isoWeek');
            } else if (frequency === 'daily') {
                date = moment(date).subtract(1, 'days');
            } else {
                date = moment(date).startOf('month');
            }

            return date.format('YYYY-MM-DD');
        },

        /////////////
        // events //
        /////////////

        onPersonalDataSync: function(collection) {
            var idAttribute = CPersonalDataTypes.prototype.model.prototype.idAttribute,
                toAdd = [];
            collection.each(function(model) {
                toAdd.push({
                    label: model.get('name'),
                    value: 'custom:' + model.get(idAttribute),
                    id: model.get(idAttribute)
                });
            }, this);
            this.collection.add(toAdd);
        },

        onProfileSync: function(model) {
            this.datasetUnit = this.getDatasetUnit(this.view.series.getValue() || 'waistline');
        },

        onResize: function(e, width) {
            var view = this.view.chart;
            if (view.onResize) {
                view.onResize(width);
            }
        },

    };
});

